

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { toast } from "react-toastify";

const initialState = {

    gelenTeklifData: null,
    gelenSurucuOnayData: null,

    notificationList: [],

    selectedNotification: null,

    topPagesNotificationsCounts: null,
    topPagesCounts: null,

    isLoadingGet: false,
    isErrorGet: false,
    isLoadingUpdate: false,
    isErrorUpdate: false,

}

//! notificationType === 1 // teklif
//! notificationType === 2 // sürücü onayi
//! notificationType === 3 // yukleme
//! notificationType === 4 // seferde
//! notificationType === 5 // bosaltma
//! notificationType === 6 // tamamlanan

export const getTopPagesNotificationsCounts = createAsyncThunk("notification/getTopPagesNotificationsCounts", async({companyList}, thunkApi)=> {
    try {

        const queryParams = companyList?.length > 0 ? companyList.map(company => `CompanyId=${company?.id}`).join("&"): "";
        const {data} = await axiosInstance.get(`/SignalR/GetLoadNotificationCounts${queryParams ? `?${queryParams}` : ""}`)
        
        return data 
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const setLoadNotificationAsRead = createAsyncThunk("notification/SetLoadNotificationAsRead", async(idList, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/SignalR/SetLoadNotificationAsRead`, idList)

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! üst alan bildirimler için get
export const getAllNotifications = createAsyncThunk("notification/getAllNotifications", async(_, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/WebNotifications/GetAllNotification`)
        
        return data.data.$values
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! üst alan bildirimler için okundu işlemi

export const markNotificationAsRead = createAsyncThunk("notification/markNotificationAsRead", async(id, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/WebNotifications/MarkNotificationAsRead`, id)
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {

        //! bu bildirim geldiğinde değişecek olan (şimdilik kullanılmıyor, bildirim içinde bilgi istenirse kullanılacak)
        setGelenTeklifNotification: (state, action) => {
            state.gelenTeklifData = action.payload
        },

        //! bu bildirim geldiğinde değişecek olan (şimdilik kullanılmıyor, bildirim içinde bilgi istenirse kullanılacak)
        setGelenSurucuOnayi: (state,action) => {
            state.gelenTeklifData = action.payload
        },

        setSelectedNotification: (state, action) => {
            state.selectedNotification = action.payload
        }


    },
    
    extraReducers:(builder)=> {
        builder

        //! getTopPagesNotificationsCounts
        .addCase(getTopPagesNotificationsCounts.pending, (state)=> {
        })

        .addCase(getTopPagesNotificationsCounts.fulfilled, (state, action)=> {
            state.topPagesNotificationsCounts = action.payload.notificationCount
            state.topPagesCounts = action.payload.waitingLoadAndShipmentCountForPanelResult.data
        })

        .addCase(getTopPagesNotificationsCounts.rejected, (state, action)=> {
        })

        //! setLoadNotificationAsRead
        .addCase(setLoadNotificationAsRead.pending, (state)=> {
        })

        .addCase(setLoadNotificationAsRead.fulfilled, (state, action)=> {
            state.topPagesNotificationsCounts = action.payload
        })

        .addCase(setLoadNotificationAsRead.rejected, (state, action)=> {
        })

        //! getAllNotifications
        .addCase(getAllNotifications.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getAllNotifications.fulfilled, (state, action)=> {
            state.isLoadingGet = false
            state.notificationList = action.payload
        })

        .addCase(getAllNotifications.rejected, (state, action)=> {
            state.isLoadingGet = false
            state.isErrorGet = true
        })
        //! markNotificationAsRead
        .addCase(markNotificationAsRead.pending, (state)=> {
            state.isLoadingUpdate = true
        })

        .addCase(markNotificationAsRead.fulfilled, (state, action)=> {
            state.isLoadingUpdate = false
            state.notificationList = state.notificationList.map((item) => {
                if(item.id === action.payload.id){
                    return action.payload
                }else{
                    return item
                }
                
            })
        })

        .addCase(markNotificationAsRead.rejected, (state, action)=> {
            state.isLoadingUpdate = false
            state.isErrorUpdate = true
        })
        
        
    }
})


export const {setGelenTeklifNotification, setGelenSurucuOnayi, setSelectedNotification} = notificationSlice.actions
export default notificationSlice.reducer
